import React, { useContext } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { useWindowSize } from "rooks";
import GratefulDB from "../../GratefulDB";
import GratefulDBContext from "../../GratefulDBContext";
import AUD from "../../images/AUD.png";
import EntryFavoriteToggleIcon from "../shared/EntryFavoriteToggleIcon";
import EntryImage from "../shared/EntryImage";
import EntryTags from "../shared/EntryTags";
import EntryVenueCoverageMultiline from "../shared/EntryVenueCoverageMultiline";
import { AudioControls } from "../shared/useAudioControls";
import { useNavUtils } from "../shared/useNavUtils";
import "./ShowResult.scss";

const ShowResult: React.FC<{
  audioControls: AudioControls;
}> = (props): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const SBD = require(`../../images/${process.env.REACT_APP_SBD_IMAGE}`);

  const params = useParams();
  const location = useLocation();
  const navUtils = useNavUtils();
  const size = useWindowSize();
  const gratefulDB = useContext<GratefulDB>(GratefulDBContext);
  const entry = params.entryId ? gratefulDB.get(params.entryId) : null;
  if (!entry) {
    return <Navigate to="/" replace />;
  }

  const containsSearchTerm = (term: string) => {
    if (!location.state || !location.state.term) {
      return false;
    }
    if (location.state.term.length < 3) {
      return false;
    }
    return term.toLowerCase().includes(location.state.term.toLowerCase());
  };

  return (
    <div className="ShowResult">
      <div className={entry.isSoundboard ? "hero sbd" : "hero aud"}>
        <div className="ui container grid">
          <div className="eight wide column tablet computer only">
            {entry.image ? (
              <div className="ui image right floated">
                <EntryImage image={entry.image} />
              </div>
            ) : (
              <img
                className="ui medium bordered image right floated"
                src={entry.isSoundboard ? SBD : AUD}
              />
            )}
          </div>
          <div className="sixteen wide mobile eight wide tablet eight wide computer column">
            <h1 className="ui header">
              <div>
                {entry.date} <EntryFavoriteToggleIcon entry={entry} />
              </div>
              <EntryVenueCoverageMultiline entry={entry} />
            </h1>
            <EntryTags
              entry={entry}
              showShareButton={true}
              showDownloadButton={true}
            />
          </div>
        </div>
      </div>
      <h4 className="ui horizontal divider header">
        <i className="music icon" />
        Tracks
      </h4>
      <div className="ui container">
        <div className="ui relaxed items link divided">
          {entry.tracks.map((track) => (
            <div
              className="item"
              onClick={() => {
                props.audioControls.selectTrack(entry, track, false);
                if (size.innerWidth && size.innerWidth < 768) {
                  navUtils.mobilePlayer();
                }
              }}
              key={track.name}
            >
              <div className="ui tiny image tracknumber mobile-hidden">
                {entry.image ? (
                  <EntryImage image={entry.image} />
                ) : (
                  <img src={entry.isSoundboard ? SBD : AUD} />
                )}
              </div>
              <div className="ui middle aligned content">
                <h3
                  className={`ui header ${
                    containsSearchTerm(track.title) ? "search-term" : ""
                  }`}
                >
                  {props.audioControls.isActiveTrack(entry, track) ? (
                    <i className="volume up icon active-track" />
                  ) : null}
                  {track.title}
                </h3>
                <h4 className="ui header right floated">{track.length}</h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShowResult;
